import type { Constituent, Customer, User } from "@/types"
import getDrawerUser from "@/components/helpers/getDrawerUser"
import { createAppSelector, createSelectorFn } from "@/store/reduxUtils"
import { useAppSelector } from "@/store/store"

export const customerSelectorFn = createSelectorFn<Customer | null>(
  (state) => state.customer.user.customer,
)
export const customerIdSelectorFn = createSelectorFn<number | null>(
  (state) => state.customer.user.customer?.id ?? null,
)

export const useCustomer = () => useAppSelector(customerSelectorFn)
export const useCustomerId = () => useAppSelector(customerIdSelectorFn)

export const currentUserSelectorFn = createSelectorFn<User | null>(
  (state) => state.profile.user.currentUser,
)
export const useCurrentUser = () => useAppSelector(currentUserSelectorFn)

export const currentConstituentSelectorFn = createSelectorFn<Constituent | null>(
  (state) => state.profile.user.currentConstituent,
)
export const useCurrentConstituent = () => useAppSelector(currentConstituentSelectorFn)

export const showAdminViewSelectorFn = createSelectorFn<boolean>(
  (state) => state.permissions.admin.showAdminView,
)
export const useShowAdminView = (): boolean => useAppSelector(showAdminViewSelectorFn)

export const selectedUserSelectorFn = createSelectorFn<User | null>(
  (state) => state.search.user.selectedUser,
)
export const getSelectedUser = () => useAppSelector(selectedUserSelectorFn)

/** WARN: returns user if one is selected */
export const useDrawerConstituent = () =>
  useAppSelector(
    createAppSelector(
      [selectedUserSelectorFn, currentConstituentSelectorFn],
      (selectedUser, currConst) => getDrawerUser(selectedUser, currConst),
    ),
  )
// export const useDrawerConstituent = () =>
//   useAppSelector(({ search, profile }) =>
//     getDrawerUser(search.user.selectedUser, profile.user.currentConstituent),
//   )

export const useDrawerUser = () =>
  useAppSelector(
    createAppSelector(
      [selectedUserSelectorFn, currentUserSelectorFn],
      (selectedUser, currentUser) => getDrawerUser(selectedUser, currentUser),
    ),
  )

// export const useDrawerUser = () =>
//   useAppSelector(({ search, profile }) =>
//     getDrawerUser(search.user.selectedUser, profile.user.currentUser),
//   )

export const selectedUserIsConstituentFn = createSelectorFn(
  (state) => state.search.user.selectedUserIsConstituent,
)
export const useIsConstituent = () => useAppSelector(selectedUserIsConstituentFn)

export const useIsLoggedIn = () => useAppSelector((state) => state.access.user.loggedIn)
